export const NUM_CURATED_TRAILS = 500; // thousand
export const NUM_USERS = 90; // million
export const LOGGED_DISTANCE = 2896819200000; // meters
